import { connect } from "react-redux";
import { mapStateToMyProfile } from "../mapToProps";
import { MyProfileView } from "../views/myProfileView";

export const ProfilePresenter = connect(mapStateToMyProfile)
(MyProfileView)